import LinearProgress from "@mui/material/LinearProgress";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React from "react";
import { styled } from "@mui/material/styles";
import { Panel } from "@poseidon/ui/components/Panel";
import Box from "@mui/material/Box";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import GetAppIcon from "@mui/icons-material/GetApp";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DoneIcon from "@mui/icons-material/Done";
import { CurrencyCell } from "@poseidon/ui/components/table/CurrencyCell";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const IconCircle = styled(Box)(({ theme }) => {
  return {
    borderRadius: "50%",
    display: "inline-flex",
    alignItems: "center",
    alignContent: "center",
    padding: 4,
    verticalAlign: "middle",
    "& svg": {
      fill: "white",
    },
  };
});
const TransactionIcon = ({ transaction }) => {
  if (transaction.type === "Interest") {
    return (
      <IconCircle sx={{ backgroundColor: "info.main", mr: 1 }}>
        <TrendingUpIcon />
      </IconCircle>
    );
  }
  if (transaction.type === "Repayment") {
    return (
      <IconCircle sx={{ backgroundColor: "success.main", mr: 1 }}>
        <GetAppIcon />
      </IconCircle>
    );
  }
  if (transaction.type === "Settlement") {
    return (
      <IconCircle sx={{ backgroundColor: "success.main", mr: 1 }}>
        <DoneIcon />
      </IconCircle>
    );
  }
  if (transaction.type === "Initial Advance") {
    return (
      <IconCircle sx={{ backgroundColor: "error.main", mr: 1 }}>
        <FileUploadIcon />
      </IconCircle>
    );
  }
  if (transaction.type === "Transfer" && transaction.amount > 0) {
    return (
      <IconCircle sx={{ backgroundColor: "success.light", mr: 1 }}>
        <ArrowForwardIcon />
      </IconCircle>
    );
  }
  if (transaction.type === "Transfer" && transaction.amount < 0) {
    return (
      <IconCircle sx={{ backgroundColor: "error.light", mr: 1 }}>
        <ArrowBackIcon />
      </IconCircle>
    );
  }
  return null;
};

const formatPaymentNumber = ({ paymentNumber, scheduleNumber }) => {
  if (!scheduleNumber) {
    return "-";
  }
  return `#${scheduleNumber}.${paymentNumber ?? 0}`;
};
export const TransactionsTable = ({ transactions, loading, error }) => {
  return (
    <Panel nopadding expandable title="Transactions">
      {loading && <LinearProgress />}
      {error && "Error!"}
      {!loading && !error && (
        <Table>
          <TableHead>
            <StyledTableRow>
              <TableCell component="th">Date/Time</TableCell>
              <TableCell component="th">Type</TableCell>
              <TableCell component="th">Repayment</TableCell>
              <TableCell component="th">Amount</TableCell>
              <TableCell component="th">Note</TableCell>
              <TableCell component="th">Capital Balance</TableCell>
              <TableCell component="th">Interest Balance</TableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {transactions
              .filter(({ type }) => type !== "Transfer")
              .map((trans) => (
                <StyledTableRow key={trans.id}>
                  <TableCell>
                    {trans.timestamp.toLocaleString("en-GB")}
                  </TableCell>
                  <TableCell>
                    <TransactionIcon transaction={trans} />
                    {trans.type}
                  </TableCell>
                  <TableCell>{formatPaymentNumber(trans)}</TableCell>
                  <CurrencyCell value={trans.amount} />
                  <TableCell>{trans.note}</TableCell>
                  <CurrencyCell value={trans.capitalBalance} />
                  <CurrencyCell value={trans.interestBalance} />
                </StyledTableRow>
              ))}
          </TableBody>
        </Table>
      )}
    </Panel>
  );
};
